// Add cookie information to google tag manager
function pushCookieTypesToDataLayer(types) {
  window.dataLayer.push({
    event: 'enableCookie',
    cookieTypes: types,
  });

  types.split(',').forEach((type) => {
    window.dataLayer.push({
      event: 'enableCookie',
      cookieType: type,
    });
  });
}

export { pushCookieTypesToDataLayer };
